import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {MinimumGamblingAgeIconDefaultBox} from "./minimum-gambling-age-icon.default.box";
import {MinimumGamblingAgeIconSiBox} from "./minimum-gambling-age-icon.si.box";

export const MinimumGamblingAgeIconBox = styledByTheme(MinimumGamblingAgeIconDefaultBox).forSI(MinimumGamblingAgeIconSiBox).apply();